'use client'

import type React from 'react'
import { useMemo } from 'react'
import { cx } from 'utils/cx'

import type { SizeGuideList, SizeGuideUnit } from '../../../types'
import { parseSizeGuide } from '../../../utils/parseSizeGuide/parseSizeGuide'
import { SizeGuideTable } from '../SizeGuideTable/SizeGuideTable'

export interface SizeGuidesListProps {
	readonly cellHeight: number
	readonly data: SizeGuideList[]
	readonly isHighlightable: boolean
	readonly isTransformable?: boolean
	readonly className?: string
	readonly unit?: SizeGuideUnit
}

export function SizeGuidesList({
	cellHeight,
	data,
	isHighlightable,
	isTransformable,
	className,
	unit,
}: SizeGuidesListProps): React.ReactNode {
	const sizeGuideParsed = useMemo(() => data && parseSizeGuide(data), [data])

	return data && (unit || !isTransformable)
		? sizeGuideParsed.map((sizeGuideGroup, sizeGuideGroupIndex) => (
				<div
					data-testid='size-guide-table'
					className={cx(className)}
					key={`${sizeGuideGroupIndex.toString()}`}
				>
					{sizeGuideGroup.sizeGuides.map((sizeGuide, sizeGuideIndex) => (
						<SizeGuideTable
							showTitle={sizeGuideGroup.sizeGuides.length !== 1}
							unit={unit}
							cellHeight={cellHeight}
							sizeGuide={sizeGuide}
							isHighlightable={isHighlightable}
							isTransformable={isTransformable}
							title={sizeGuideIndex === 0 ? sizeGuideGroup.name : undefined}
							key={`${sizeGuideIndex.toString()}`}
						/>
					))}
				</div>
			))
		: null
}
